/**
 * BlisTop facets enhancement - owner request 2026-08-05.
 *
 * Keeps the mobile drawer's sticky footer CTA in sync with the live result
 * count. facets.js re-renders the header `.mobile-facets__count` on every AJAX
 * pass but never touches the footer, so a MutationObserver mirrors the header
 * count into the footer button ("הצגת N מוצרים").
 */
(() => {
  const headerCount = document.querySelector('.mobile-facets__count');
  const footerCount = document.querySelector('[data-blistop-mobile-count]');
  if (!headerCount || !footerCount) return;

  const sync = () => {
    const text = (headerCount.textContent || '').trim();
    if (!text) return;
    const next = `הצגת ${text}`;
    if (footerCount.textContent.trim() !== next) footerCount.textContent = next;
  };

  sync();
  const observer = new MutationObserver(sync);
  observer.observe(headerCount, { childList: true, subtree: true, characterData: true });
})();
